import {AfterContentInit, Component, ElementRef, ViewChild, ViewEncapsulation} from '@angular/core';
import {
  LanguageStore
}                                                                              from '../../stores/translation/language.store';
import {
  TranslationStore
}                                                                              from '../../stores/translation/translation.store';
import {
  ApDynformsConfigFieldset
}                                                                              from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {DomSanitizer, SafeHtml}                                                from '@angular/platform-browser';

@Component({
  selector: 'ap-info-legal',
  template: `
    <div>
    </div>
    <ap-dynforms [fieldsets]="formConfig" [caption]="caption">
      <div dynforms.after>
        <div #imprint_text
             class="impressum-block"
             [innerHTML]="sanitizedImprintText"
        ></div>
        <div class="trademark-notice">
          <p>AGRICON® and AGRIPORT® are registered trademarks of Agricon GmbH, Jahnatal.</p>
        </div>
        <div class="gdpr-block">
          <a [href]="url"
             [download]="'gdpr.pdf'"
             [text]="'General_Data_Protection_Regulation' | translate"
          ></a>
        </div>
      </div>
    </ap-dynforms>
  `,
  styles: [`
    .impressum-block {
      line-height: 1.4;
    }

    .impressum-block p {
      margin: 0;
      padding: 0;
      font-size: 14px;
    }

    .impressum-block p:has(strong) {
      margin-top: 2em;
      margin-bottom: 0.7em;
    }

    .impressum-block p:first-child:has(strong) {
      margin-top: 0;
    }

    .impressum-block p + p:not(:has(strong)) {
      margin-top: 0.2em;
    }

    .trademark-notice p {
      margin-top: 2em;
      text-align: left;
      font-size: 0.9em;
      color: #666;
    }

    .gdpr-block {
      margin-top: 2em;
      margin-bottom: 0.7em;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class InfoLegalComponent implements AfterContentInit {
  @ViewChild('imprint_text', {static: true, read: ElementRef}) imprintTextElement: ElementRef;

  public url: string;
  public imprintText: string;
  public formConfig: ApDynformsConfigFieldset[];
  public caption: string;
  public sanitizedImprintText: SafeHtml;

  constructor(
    private language: LanguageStore,
    private translationStore: TranslationStore,
    private sanitizer: DomSanitizer
  ) {
  }

  public ngAfterContentInit(): void {
    this.imprintText = this.translationStore.FindTranslationForSelectedLanguage('Global_Imprint_Text');
    const cleanedHtml = this._cleanHtml(this.imprintText);
    this.sanitizedImprintText = this.sanitizer.bypassSecurityTrustHtml(cleanedHtml);
    this.url = this.language.SelectedLanguage?.Key === 'de'
      ? '/assets/info/legal/gdpr_de.pdf'
      : '/assets/info/legal/gdpr_en.pdf';
    this.formConfig = [
      new ApDynformsConfigFieldset({
        key: 'contact_fieldset',
        columns: 1,
        legend: 'Impressum',
        config: []
      })
    ];
  }

  private _cleanHtml(html: string): string {
    return html
      // Remove empty paragraphs with &nbsp;
      .replace(/<p[^>]*>&nbsp;<\/p>/g, '')
      // Clean up problematic style attributes
      .replace(/style="" line-height:="" 10%;""="">/g, '>')
      // Remove "Adresse:" header
      .replace(/<p><strong>Adresse:<\/strong><\/p>/g, '')
      // Remove any leftover empty paragraphs
      .replace(/<p>\s*<\/p>/g, '');
  }
}
